import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Nav } from './pageComponents/nav';
import { Footer } from './pageComponents/footer';
import { ProjectList } from './pageComponents/projectList';
import { ContectUs } from './pageComponents/contectUs';
import { Skills } from './pageComponents/skills';
import { SkillsIcons } from './pageComponents/skillsIcons';
import { LandingPage } from './pageComponents/landingPage';
import { Profile } from './pageComponents/profile';
import { RecentWork } from './pageComponents/recentWork';
import { Loader } from './pageComponents/loader';

ReactGA.initialize(process.env.REACT_APP_GA);
export const ThemeContext = React.createContext(false);
class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            repoDetails: {},
            fetching: true,
            darkMode: false,
        }
        this.getThemeMode = this.getThemeMode.bind(this);
    }

    componentDidMount() {
        this.fetchUserRepo().then(()=>{
          setTimeout(() => this.setState({ loading: false }), 10000);
        });
        ReactGA.pageview(window.location.pathname + window.location.search);
        
    }
    
    componentDidUpdate = () => ReactGA.pageview(window.location.pathname + window.location.search);

    getThemeMode(themeMode) { this.setState({ darkMode: !this.state.darkMode }); }

    fetchUserRepo = async () => {
        await fetch('https://api.github.com/users/gmpravin/repos')
            .then(res => res.json())
            .then(json => this.setState({ repoDetails: json, fetching: false }));
    }

    render() {
        const { repoDetails, fetching, darkMode } = this.state;

        console.log("Hi,Im Pravin...")
        return (
            <ThemeContext.Provider value={darkMode}>
                {this.state.loading && (<Loader />)}
                <Nav themeMode={this.getThemeMode} />
                <LandingPage />
                <Profile />
                <SkillsIcons />
                <Skills />
                <RecentWork />
                <ProjectList fetching={fetching} repoDetails={repoDetails} />
                <ContectUs />
                <Footer />
            </ThemeContext.Provider>
        )
    }

}

export default Index;
